// Browser observability setup.

import posthog from 'posthog-js';
import {
  posthogBeforeSend,
  posthogEnvironment,
  posthogRelease,
} from './util/posthog/sharedConfig';

const posthogEnabled = posthogEnvironment() === 'production';

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  // `/ingest` is proxied through Vercel (next.config.js), so every event and
  // replay chunk is billed as edge requests + origin transfer. Set
  // NEXT_PUBLIC_POSTHOG_API_HOST to a PostHog managed reverse proxy domain to
  // send straight to PostHog and keep ad-blocker resistance.
  api_host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST || '/ingest',
  ui_host: 'https://us.posthog.com',
  defaults: '2026-01-30',
  capture_exceptions: true,
  // Event budget: autocapture only real controls (clicks on links/buttons,
  // form submits). Input `change` events and clicks on bare divs/svgs were most
  // of our $autocapture volume and carried no useful label. Add
  // `data-ph-capture-attribute-*` or an explicit capture for anything else.
  autocapture: {
    dom_event_allowlist: ['click', 'submit'],
    element_allowlist: ['a', 'button', 'form'],
  },
  capture_pageleave: false,
  before_send: posthogBeforeSend,
  // Free plan: capture in production only. Starts opted-out in dev/staging.
  opt_out_capturing_by_default: !posthogEnabled,
  debug: process.env.NODE_ENV === 'development',
});

if (posthogEnabled) {
  // Tag every PostHog event with deployment context.
  posthog.register({
    service: 'attik-frontend',
    runtime: 'browser',
    environment: posthogEnvironment(),
    ...(posthogRelease() ? { release: posthogRelease() } : {}),
  });
}
